// ink-component
import React, { useContext } from 'react';
import { ThemeContext } from 'styled-components';

import { CoreVerticalNavElement } from '../../_common/CoreVerticalNavElement';

export interface VerticalNavAnchorProps extends React.AnchorHTMLAttributes<HTMLAnchorElement> {
  /** Defines the active state */
  active?: boolean;
  /** Wrap or ellipse the test */
  whiteSpace?: string;
}

/**
 * @group VerticalNav
 * @categories navigation
 * @purpose Anchor item of VerticalNav
 * @order 1
 */
export function VerticalNavAnchor(props: VerticalNavAnchorProps) {
  const { active, whiteSpace, className, style, ...otherProps } = props;
  const currentTheme = useContext(ThemeContext);

  const theme = { ...currentTheme, active, whiteSpace };

  return <CoreVerticalNavElement theme={theme} {...otherProps} tabIndex={0} as="a" />;
}

VerticalNavAnchor.defaultProps = {
  active: undefined,
  whiteSpace: undefined,
};

VerticalNavAnchor.displayName = 'VerticalNav.Anchor';

export default VerticalNavAnchor;
